/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationOfferGroupProtectionMutation from '../graphql/mutations/SaveSimulationOfferGroupProtectionMutation.js';

export const useSaveSimulationOfferGroupProtectionMutation = () => {
  return useCommitMutation(SaveSimulationOfferGroupProtectionMutation, { dataProp: 'saveSimulationOfferGroupProtection_M_simulation_offer_group_protection' });
};

export default useSaveSimulationOfferGroupProtectionMutation;
